// Vendors
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useKycContextConsumerHook } from 'containers/kyc/contexts/kyc.context';
// Event Handlers
import { KycMethodHandlers } from '../handlers/kyc-method.handlers';
// Types
import { KycMethodHookType } from './types/kyc-method.hook.type';

const useKycMethodHook = (): KycMethodHookType => {
  const [showLoader, setShowLoader] = useState(false);
  const { handleUpdateKycHeaderBackClick, kycIdentificationId, kycIframeUrl, selectedMethod } =
      useKycContextConsumerHook(),
    { setCurrentState, setOnHeaderBackClick } = useAppContextConsumerHook();

  const { showBoundary: setError } = useErrorBoundary();

  useEffect(() => {
    setOnHeaderBackClick(() => handleUpdateKycHeaderBackClick);
    return () => {
      setOnHeaderBackClick(null);
    };
  }, []);

  return {
    ...KycMethodHandlers({
      kycIdentificationId,
      selectedMethod,
      setCurrentState,
      setError,
      setShowLoader,
    }),
    kycIframeUrl,
    selectedMethod,
    showLoader,
  };
};

export { useKycMethodHook };
